"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Feature_js_1 = __importDefault(require("ol/Feature.js"));
var Point_js_1 = __importDefault(require("ol/geom/Point.js"));
var layer_js_1 = require("ol/layer.js");
var Vector_js_1 = __importDefault(require("ol/source/Vector.js"));
var style_js_1 = require("ol/style.js");
var LineString_1 = __importDefault(require("ol/geom/LineString"));
var ShipLayer = /** @class */ (function () {
    // var resolutionnn = null;
    function ShipLayer() {
        var self = this;
        var styles = function (feature, resolution) {
            var type = feature.get('type');
            var icon = new style_js_1.Icon({
                anchor: [0.5, 1],
                scale: 0.5,
                src: '/assets/icons/ship.svg'
            });
            var icon_active = new style_js_1.Icon({
                anchor: [0.5, 1],
                scale: 0.5,
                src: '/assets/icons/ship-active.svg'
            });
            var scale = resolution < 1000 ? _.min([0.8, (0.5 + (resolution < 100 ? 10 / resolution : 100 / resolution))]) : 0.5;
            icon.setScale(scale);
            icon_active.setScale(scale);
            var styles = {
                point: new style_js_1.Style({
                    image: icon
                }),
                route: new style_js_1.Style({
                    stroke: new style_js_1.Stroke({
                        color: 'rgba(102, 102, 102, 0.5)',
                        width: 2
                    })
                }),
                point_active: new style_js_1.Style({
                    image: icon_active
                })
            };
            return styles[type];
        };
        this.layer = new layer_js_1.Vector({
            source: new Vector_js_1.default({
                features: []
            }),
            style: styles
        });
        this.layer.setZIndex(150);
    }
    ShipLayer.prototype.addFeature = function () {
        var feature = new Feature_js_1.default({
            geometry: new Point_js_1.default([0, 0]),
            type: 'point'
        });
        this.layer.getSource().addFeature(feature);
        return feature;
    };
    ShipLayer.prototype.get = function () {
        return this.layer;
    };
    ShipLayer.prototype.drawRoute = function (points) {
        var feature = new Feature_js_1.default({
            geometry: new LineString_1.default(points),
            type: 'route'
        });
        this.layer.getSource().addFeature(feature);
        return feature;
    };
    ShipLayer.prototype.setPosition = function (feature, position) {
        feature.getGeometry().setCoordinates(position);
    };
    ShipLayer.prototype.setRouteStyle = function (route_feature) {
        route_feature.setStyle(new style_js_1.Style({
            stroke: new style_js_1.Stroke({
                color: 'rgb(102, 102, 102)',
                width: 3
            })
        }));
    };
    ShipLayer.prototype.defaultRouteStyle = function (route_feature) {
        route_feature.setStyle(new style_js_1.Style({
            stroke: new style_js_1.Stroke({
                color: 'rgba(102, 102, 102, 0.5)',
                width: 2
            })
        }));
    };
    ShipLayer.prototype.setShipActive = function (ship_feature) {
        var feature = new Feature_js_1.default({
            geometry: new Point_js_1.default([0, 0]),
            type: 'point_active'
        });
        this.layer.getSource().addFeature(feature);
        return feature;
    };
    ShipLayer.prototype.setMessageFeature = function (color) {
        var feature = new Feature_js_1.default({
            geometry: new Point_js_1.default([0, 0])
        });
        feature.setStyle(new style_js_1.Style({
            image: new style_js_1.Circle({
                radius: 8,
                fill: new style_js_1.Fill({ color: color }),
                stroke: new style_js_1.Stroke({ color: '#000000', width: 1 })
            })
        }));
        this.layer.getSource().addFeature(feature);
        return feature;
    };
    ShipLayer.prototype.getExtent = function () {
        return this.layer.getSource().getExtent();
    };
    ShipLayer.prototype.removeFeature = function (feature) {
        this.layer.getSource().removeFeature(feature);
    };
    return ShipLayer;
}());
exports.default = ShipLayer;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/dashboard/classes/ship.js
// module id = 383
// module chunks = 0